export enum RouteQueryKey {
  UnavailableWorkspace = 'unavailableWorkspace',
}
